<template>
  <section class="customer-filter">
    <sk-select :items-list="customerTypes"
               class="customer-filter__select"
               :preselected-value="selectedCustomerType"
               :default-value="placeholder"
               @csvaluechanged="onInputBoxChanged" />
    <button class="customer-filter__reset-icon"
            @click="resetType"></button>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        selectedCustomerType: ''
      };
    },
    computed: {
      customerTypes() {
        return [
          {id: 'enterpriseCustomerType', name: this.$gettext('Enterprise')},
          {id: 'privateCustomerType', name: this.$gettext('Private')},
          {id: 'undefinedCustomerType', name: this.$gettext('Undecided')}
        ];
      },
      placeholder() { return this.$gettext('Select a customer'); },

    },
    methods: {
      onInputBoxChanged(value) {
        this.selectedCustomerType = value;
        if (this.selectedCustomerType === '') {
          return;
        }
        this.params.parentFilterInstance((instance) => {
          instance.onFloatingFilterChanged('inList', value);
        });
      },

      onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null value here
        if (!parentModel) {
          this.selectedCustomerType = '';
        }
      },
      resetType() {
        this.selectedCustomerType = '';
        this.params.parentFilterInstance((instance) => {
          instance.onFloatingFilterChanged('', '');
        });
      }
    }
  };
</script>

<style>
.customer-filter .sk-select {
  background-color: #fff;
  font-weight: normal;
  font-size: 13px;
}

.customer-filter {
  display: flex;
  width: 100%;
}

.customer-filter__select {
  width: 80%;
}

.customer-filter__reset-icon {
  align-self: center;
  width: 20px;
  height: 25px;
  margin-left: 5px;
  background-image: url(~@assets/imgs/undefined_imgs/close_x_icon_blue.svg);
  background-position: 50% 50%;
  background-size: 13px auto;
  background-repeat: no-repeat;
  cursor: pointer;
}
</style>
